import React, { useEffect } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { Banner, ThumbnailBanner } from '../../componentes/banner/banner'
import { SessaoHeader } from '../../componentes/sessoes/sessao-header/sessao-header'
import { gestorReqs } from '../../servicos/gestor'
import { toTop } from '../../utilidades/manipuladores-html'
import { useTitle } from '../../utilidades/tittle'
import './pagina-produtos.scss'

export const PaginaProdutos = () => {

  const categoria = useLocation().pathname.split('/').at(3);
  const categoriaFormat = categoria ? decodeURIComponent(categoria.replace(/-/g, ' ')) : '';
  const categoriaTitle = categoriaFormat.charAt(0).toUpperCase() + categoriaFormat.slice(1);

  useTitle(`${categoriaTitle} - Real Metais`);
  
  return (
    <section id='paginaProdutos'>
      <SessaoHeader variant='opaque' />
      <div className="ancora"></div>
      <Outlet />
    </section>
  )
}